module.exports = __webpack_public_path__ + "img/fill_3.320023bc.svg";